import { C_REALESTATE_TYPES } from "@/src-refactor/modules/private/realestate/components/forms/descriptions-step/components/Features";
import { C_REALESTATE_TYPES_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareMeterContrutionLandToServer = (body: IPropertyForm) => {
  // if (HCheckArray(body.type_property)) {
  //   if (body.type_property[0].value == C_REALESTATE_TYPES.APARTMENT.value) {
  //     return {
  //       sqm_land: body.meter_construction_property,
  //       sqm_construction: body.meter_construction_property
  //     };
  //   }
  //   return {
  //     sqm_land: body.meter_land_property,
  //     sqm_construction: body.meter_construction_property
  //   };
  // }
  return {
    sqm_land: body.meter_land_property,
    sqm_construction: body.meter_construction_property
  };
};

export default prepareMeterContrutionLandToServer;
